/*!
 * Copyright 2024 Cognite AS
 */

/**
 * @beta
 */
export enum FlexibleControlsType {
  OrbitInCenter = 'orbitInCenter',
  FirstPerson = 'firstPerson',
  Orbit = 'orbit'
}
